/**
 * Belo Image Carousel
 * 
 * This JavaScript file handles the image carousel functionality for the product images.
 * It allows users to navigate through the product images using thumbnails.
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get all carousel elements
  const carouselItems = document.querySelectorAll('.carousel-item');
  const thumbnails = document.querySelectorAll('.thumbnail');
  
  // Set up thumbnail click events
  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', function() {
      // Remove active class from all carousel items and thumbnails
      carouselItems.forEach(item => item.classList.remove('active'));
      thumbnails.forEach(thumb => thumb.classList.remove('active'));
      
      // Add active class to the clicked thumbnail and corresponding carousel item
      this.classList.add('active');
      carouselItems[index].classList.add('active');
    });
  });
  
  // Set the first thumbnail and carousel item as active by default
  if (thumbnails.length > 0 && carouselItems.length > 0) {
    thumbnails[0].classList.add('active');
    carouselItems[0].classList.add('active');
  }
  
  // Optional: Add swipe functionality for mobile devices
  let touchStartX = 0;
  let touchEndX = 0;
  
  const carousel = document.querySelector('.product-image-carousel');
  
  if (carousel) {
    carousel.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, false);
    
    carousel.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, false);
  }
  
  function handleSwipe() {
    // Find the currently active item
    const activeItem = document.querySelector('.carousel-item.active');
    const activeIndex = Array.from(carouselItems).indexOf(activeItem);
    
    if (touchEndX < touchStartX) {
      // Swipe left - go to next image
      const nextIndex = (activeIndex + 1) % carouselItems.length;
      carouselItems.forEach(item => item.classList.remove('active'));
      thumbnails.forEach(thumb => thumb.classList.remove('active'));
      
      carouselItems[nextIndex].classList.add('active');
      thumbnails[nextIndex].classList.add('active');
    } else if (touchEndX > touchStartX) {
      // Swipe right - go to previous image
      const prevIndex = (activeIndex - 1 + carouselItems.length) % carouselItems.length;
      carouselItems.forEach(item => item.classList.remove('active'));
      thumbnails.forEach(thumb => thumb.classList.remove('active'));
      
      carouselItems[prevIndex].classList.add('active');
      thumbnails[prevIndex].classList.add('active');
    }
  }
  
  // Optional: Add automatic slideshow functionality
  let slideInterval;
  const slideDelay = 5000; // 5 seconds
  
  function startSlideshow() {
    slideInterval = setInterval(function() {
      const activeItem = document.querySelector('.carousel-item.active');
      const activeIndex = Array.from(carouselItems).indexOf(activeItem);
      const nextIndex = (activeIndex + 1) % carouselItems.length;
      
      carouselItems.forEach(item => item.classList.remove('active'));
      thumbnails.forEach(thumb => thumb.classList.remove('active'));
      
      carouselItems[nextIndex].classList.add('active');
      thumbnails[nextIndex].classList.add('active');
    }, slideDelay);
  }
  
  function stopSlideshow() {
    clearInterval(slideInterval);
  }
  
  // Start slideshow on page load (uncomment to enable)
  // startSlideshow();
  
  // Pause slideshow when hovering over carousel (uncomment to enable)
  // carousel.addEventListener('mouseenter', stopSlideshow);
  // carousel.addEventListener('mouseleave', startSlideshow);
});
